module.exports = __webpack_public_path__ + "static/img/ent-detail-58.93b8724.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-58.jpg
// module id = Pg1p
// module chunks = 51